






import { Component, Vue } from 'vue-property-decorator'
import { QueryParam, ColumnType, Column } from '@/api/model/DefaultPageEntity'
import { translate } from '@/utils/filters'
import DefaultVuePage from '@/components/common/DefaultVuePage.vue'
import $Api from '@api'
import { finalize } from 'rxjs/operators'

@Component({
    components: {
        DefaultVuePage
    }
})
export default class RepaymentDetail extends Vue {
    tableLoading = false
    externalParam: any = { current: 1, size: 10, deductId: '' };
    ListColumn: Column[] = [
        { prop: 'id', columnName: 'ID', desc: 'ID', width: '140' },
        { prop: 'channelName', columnName: translate('channel.channelName') as string, desc: '渠道名称' },
        { prop: 'bankName', columnName: translate('bank.title') as string, desc: '银行名称' },
        { prop: 'otherNo', columnName: translate('deduct.RepaymentCode') as string, desc: '还款码' },
        { prop: 'bankCardNo', columnName: translate('sales.bankCardNo') as string, desc: '银行账号' },
        { prop: 'payTypeDesc', columnName: translate('payType.name') as string, desc: '支付类型' },
        { prop: 'realName', columnName: translate('sales.realName') as string, desc: '真实姓名' },
        { prop: 'payStatusDesc', columnName: translate('channel.payStatus') as string, desc: '支付状态' },
        { prop: 'amount', columnName: translate('outcome.amount') as string, desc: '支付状态' },
        { prop: 'realAmount', columnName: translate('deduct.realAmount') as string, desc: '实际金额' },
        { prop: 'rtcode', columnName: translate('returnCode.name') as string, desc: '返回码' },
        { prop: 'rtmsg', columnName: translate('returnCode.returnMsg') as string, desc: '返回消息' },
        { prop: 'thirdSerialNo', columnName: translate('callRecord.filter.serialId') as string, desc: '三方流水号' },
        { prop: 'purchaseCurrency', columnName: translate('deduct.purchaseCurrency') as string, desc: '币种' },
        {
            prop: 'createTime',
            columnName: translate('cash.tableData.createTime') as string,
            desc: '创建时间',
            columnType: ColumnType.DATE
        },
        { prop: 'updateTime', columnName: translate('sales.updateTime') as string, columnType: ColumnType.DATE }
    ]
    private detail = {};

    created() {
        this.externalParam.deductId = this.$route.query.id
    }

    async getDetailList(param: QueryParam) {
        this.tableLoading = true
        $Api.receiptService
            .abroadDeductGetDetailList(param)
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(data => {
                this.detail = data
            })
    }
}
